<template>
  <div class="g-page">
    <img class="qrcode" src="../assets/img/pic-pay-code@3x.png" alt="微信扫码购买服务" />
    <div
      :style="{
        padding: '1.5rem 0 .55rem',
        textAlign: 'center',
        fontSize: '.8rem',
        fontWeight: 'bold',
        color: '#212732',
      }"
    >如何扫码</div>
    <img class="guide" src="../assets/img/guide-scan@3x.jpg" alt="微信扫码引导" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  name: 'topup',
};
</script>

<style lang="scss" scoped>
.g-page {
  padding-bottom: 2.25rem;
}

.qrcode {
  display: block;
  width: 100%;
}

.guide {
  display: block;
  width: 100%;
}
</style>
